import React from "react"
import Select from "react-select"
import _ from 'lodash'

class ViewAs extends React.Component {


    handleBlur = (v, f) => {
        this.props.onBlur(this.props.name, true)
	}
	
	pickValue = (opts, value) => {
		let arr = []
		_.forEach(opts, groups => {
			_.forEach(groups.options, row => {
				if (value == row.value) {
					arr.push(row)
				}
			})
		})
		return arr
	}

    render() {
        return (
			<>
				<Select
					className={this.props.className ? this.props.className : "form__input"}
					classNamePrefix={this.props.classNamePrefix}
					value={this.pickValue(this.props.options, this.props.value)}
					id={this.props.name}
					options={this.props.options}
					onChange={(v) => v?.value && this.props.onChange(v.value)}
					onBlur={this.handleBlur}
					isMulti={this.props.isMulti}
					isClearable={this.props.clearable}
					filterOption={(opt, val) => {
						// This is for selects where we have the options as <span>s.  It allows styling, so we have to filter based on the `text` param vs the label which will be a react element.
						try {
							let v = val ? val.toLowerCase() : ""
							let option = opt.data.text.toLowerCase()
							if (option.includes(v)) return true
						} catch (e) {
							console.error(`Option type failed in React Select.`)
						}
					}}
				/>
			</>
		)
    }
}

export default ViewAs